var _path, _path2, _circle;
import { createTablerIcon } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createTablerIcon({
  Content() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [_path || (_path = /*#__PURE__*/_jsx("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
        d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
      })), _circle || (_circle = /*#__PURE__*/_jsx("circle", {
        cx: 12,
        cy: 12,
        r: 3
      }))]
    });
  },
  name: 'settings'
});